module.exports = __webpack_public_path__ + "static/media/aboutvideo.dbcff2ef2e006e31ba88e59c0ad2d3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutvideo.png
// module id = 2708
// module chunks = 1